define('views/modules/calendar/animated-session/exercise/lists/exercise-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    'services/events/animated-session-events',
    'services/i18n',
    // views
    'views/parts/menu/menu-context',
    'views/modules/calendar/animated-session/exercise/weight/weight-content',
    'views/modules/calendar/animated-session/exercise/cardio/cardio-content',
    'views/modules/calendar/animated-session/exercise/exercise-note',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/lists/exercise-list-item.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    AnimationEvents,
    i18n,
    // views
    VMenuContext,
    VWeightContent,
    VCardioContent,
    VExerciseNote,
    // templates
    TExerciseListItem
) {

    var VExerciseListItem = Backbone.Epoxy.View.extend({
        template: TExerciseListItem,
        weightContentView: VWeightContent,
        cardioContentView: VCardioContent,

        events: {
            'click .options-toggle': 'onMenuOptionToggle',
            'click .exercise-link': 'onLinkClick',
        },

        regions: {
            menu: ".menu-options",
            confirm: ".menu-confirm",
            content: ".exercise-box-table",
            done: ".exercise-check",
            note: ".note-pane",
            thumbnail: ".exercise-thumbnail"
        },

        id: function() {
            return "exercise-item-" + this.cid;
        },

        initialize: function(opt) {
            opt = this.options = opt || {};

            var view = this.view = {},
                model = this.model,
                id = "#" + _.result(this, 'id'),
                tooltip = {
                    container: id,
                    viewport: opt.viewport || id,
                };

            this.role = opt.role;

            if (model.isWeight()) {
                view.content = view.weight = new this.weightContentView({
                    model: model,
                    tooltip: tooltip,
                    item: opt.item,
                    summary: opt.summary,
                });

            } else if (model.isCardio()) {
                view.content = view.cardio = new this.cardioContentView({
                    model: model,
                    tooltip: tooltip
                });
            }

            if (model.collection.indexOf(model) === model.collection.length - 1) {
                model.set("next", false);
            } else {
                model.set("next", model.collection.at(model.collection.indexOf(model) + 1));
            }

            this.listenTo(model, {
                "model:reset": this.onModelReset,
                "change:weeks": this.onWeekChange,
                "destroy": this.remove
            })
                .listenTo(model, { "toggle:note": this.toggleNote })
                .listenTo(model.getWeeks(), { "change:done": this.onDoneChange })
                .listenTo(AnimationEvents, { "exercise:renamed": this.onExerciseRenamed })
                .listenTo(AnimationEvents, { "exercise:edited": this.onExerciseEdited })
                .listenTo(AnimationEvents, { "exercise:reverted": this.onExerciseReverted });

        },
        render: function() {
            var model = this.model,
                animation = model.getAnimation(),
                $html = Backbone.$(Mustache.render(this.template, Mustache.getContext(_.extend(model.toJSON(), {
                    isDone: this.isWeekView() ? this.getWeekDone() : false,
                    hideTCNotes: model.get('hideTCNotes'),
                    isWeekView: this.isWeekView(),
                    isClientSide: this.role === 'client'
                }))));

            this.$el.replaceWith($html);
            this.setElement($html).applyAttributes();

            this.applyBindings();

            this.generateZones();

            // if there is custom notes OR notes that described the exercise
            if (model.hasNotes() && this.options.summary) {
                this.toggleNote(true);
            }

            this.addTimestampToThumbnail();

            this.renderContent();

            return this;
        },

        addTimestampToThumbnail: function() {
            this.zone.$thumbnail.attr('src', this.model.get('animationThumbnail') + '?' + new Date().getTime());
        },

        renderContent: function(view) {
            var viewObj = this.view,
                content = viewObj.content;
            if (view && content !== view) {
                if (content) content.disable();
                content = viewObj.content = view;
            }

            this.assign(content, this.zone.$content);
        },

        renderTooltip: function() {

        },

        setActive: function(val) {
            this.zone.$infobox.toggleClass('active', val);
        },

        toggleNote: function(val) {
            var view = this.view,
                note = view.note;
            if (!note) {
                note = view.note = new VExerciseNote({
                    model: this.model,
                    summary: this.options.summary,
                });
                this.assign(note, this.zone.$note);
            }
            note.toggle(val);
        },

        toggleDone: function(val) {
            this.zone.$done.toggleClass('completed', val);
        },

        getWeek: function() {
            return this.model.getWeek(this.options.item.getWeek());
        },

        getWeekDone: function() {
            return this.model.getWeekDone(this.options.item.getWeek());
        },

        isWeekView: function() {
            return this.options.summary;
        },

        /////////////
        // actions //
        /////////////


        onExerciseRenamed: function(exModelRenamed) {
            if (this.model.get("_animation")._id === exModelRenamed.get("exercise")._id) {
                this.$("p").first()[0].innerText = exModelRenamed.get("name");
            }
        },

        onExerciseEdited: function(model) {
            if (this.model.getAnimation()._id === model.id) {
                this.model.set('_animation', model.toJSON());
                this.render();
            }
        },

        onExerciseReverted: function(exModelReverted) {
            exModelReverted = exModelReverted[0];
            if (this.model.get('_animation')._id === exModelReverted.get('_id')) {
                this.$("p").first()[0].innerText = exModelReverted.get("name");
            }
        },

        onOptionClicked: function(e) {
            e.preventDefault();
        },

        onViewAnimationDetailsAction: function(e, actionModel) {
            this.model.trigger("exercise:detail", this.model);
        },

        onRemoveAction: function() {
            var model = this.model;
            var previousExerciseIndex = model.collection.findIndex({ index: model.get("index") }) - 1;

            if (previousExerciseIndex >= 0)
                model.collection.at(previousExerciseIndex).set({ linkNext: false });

            model.trigger('destroy', model, model.collection);
        },

        ////////////
        // events //
        ////////////

        onLinkClick: function(e) {
            if (this.role === 'supervisor') {
                this.model.set('linkNext', !Boolean(this.model.get('linkNext')));
            }
        },

        onDoneChange: function(model, value) {
            this.toggleDone(value);
        },

        onMenuOptionToggle: function(e) {
            e.preventDefault();
            var view = this.view,
                menu = view.menu;

            // message options
            var menuCollection = new Backbone.Collection([
                { caption: 'View details', icon: "sl-icon-list", callback: this.onViewAnimationDetailsAction },
                { caption: 'Remove', icon: "sl-icon-trash", callback: this.openConfirmMenu },
            ]);

            if (this.isWeekView()) {
                menuCollection.add({ caption: 'Edit', icon: "sl-icon-note", callback: this.onEditAction }, { at: 1 });
            }

            // you can't convert exercise to cardio on sessionWeekView
            // if (!this.options.item) {
            //     menuCollection.add({ caption: 'Convert to cardio', icon: "sl-icon-energy" }, { at: 1 });
            // }

            if (Viewport.isMobile()) {
                menuCollection.add([
                    { caption: 'Move up', icon: "sl-icon-arrow-up", callback: this.onMoveUpAction, id: 'up' },
                    { caption: 'Move down', icon: "sl-icon-arrow-down", callback: this.onMoveDownAction, id: 'down' }
                ], { at: 1 });
            }
            // edit isn't available on yourself

            // this.listenTo(menuCollection, "item:click", this.onOptionClicked);
            menu = view.menu = new VMenuContext({
                collection: menuCollection,
                context: this,
                onClick: this.onOptionClicked
            });
            this.assign(menu, this.zone.$menu);

            menu.toggle();
        },

        openConfirmMenu: function() {
            var view = this.view,
                confirm = view.confirm;
            if (!confirm) {
                // message options
                var menuCollection = new Backbone.Collection([
                    { caption: i18n.t('general:yes-delete'), icon: "sl-icon-check", callback: this.onRemoveAction },
                    { caption: 'Cancel', icon: "sl-icon-close" },
                ]);

                confirm = view.confirm = new VMenuContext({
                    collection: menuCollection,
                    context: this,
                    onClick: this.onOptionClicked
                });
                this.assign(confirm, this.zone.$confirm);
            }

            confirm.toggle();
        },

        onModelReset: function(attrs, options) {
            var model = this.model,
                id = "#" + _.result(this, 'id'),
                tooltip = {
                    container: id,
                    viewport: options.viewport || id,
                },
                opt = this.options;
            if (model.isWeight()) {
                this.renderContent(new VWeightContent({
                    model: model,
                    tooltip: tooltip,
                    item: opt.item,
                    summary: opt.summary,
                }));
            } else if (model.isCardio()) {
                this.renderContent(this.view.cardio);
            }
        },

        onMoveUpAction: function() {
            var $target = this.$el.prevAll('.exercise:first');
            if (!$target.length) return;
            this.model.trigger('move:up', this.$el, $target);
        },

        onMoveDownAction: function() {
            var $target = this.$el.nextAll('.exercise:first');
            if (!$target.length) return;
            this.model.trigger('move:down', this.$el, $target);
        },

    });

    return VExerciseListItem;

});

